import PropTypes from "prop-types";
import { EnterOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./chatReply.scss";

const ChatReplyActionButton = ({ onClick, className = "" }) => {
  const { t } = useTranslation("common");
  return (
    <button
      type="button"
      className={`chat-reply-action-btn ${className}`.trim()}
      aria-label={t("one_to_one.reply") || "Reply"}
      title={t("one_to_one.reply") || "Reply"}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
    >
      <EnterOutlined />
    </button>
  );
};

ChatReplyActionButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default ChatReplyActionButton;
